import { Alert } from 'antd';
import styled from 'styled-components';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';

export const UserAlertWrapper = styled(Alert).attrs({
  banner: true,
  closable: true,
})`
  padding: 8px 26px;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const ButtonLink = styled(Button).attrs({
  type: ButtonTypeEnum.Link,
})`
  display: inline;
  padding: 0 4px;
`;
